// import CustomSlider from "../Common/CustomSlider";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import { Link } from "react-router-dom";
// import Swiper core and required modules
import { Autoplay, Navigation, Pagination } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";

import { isMobile } from "react-device-detect";


function TestimonialsSlider({ componentData }) {
  if (!componentData) return null;

  const navigation_status = isMobile? false:true;  
  const slide_per_view = isMobile?1:1;
  const testimonial_urls = ["testimonials","authentic","shipping-information","payment-methods"];

  // var settings = {
  //   className: "acc-crousel mt-30",
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   cssEase: "linear",
  //   mobileFirst: true,
  //   arrows: false
  // };
  return (
    // <section className="testimonial-slider bg-light mt-20 spacer">
    <section className="banner home-banner mt-15 top-sales-banner">
      {/* <div className="container-fluid">
        <div className="row"> */}
          <div className="col-md-12">
            {/* <CustomSlider settings={settings}> */}
            <Swiper
              slidesPerView={slide_per_view}
              spaceBetween={20}
              centeredSlides={false}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              navigation={navigation_status}
              loop={true}
              modules={[Autoplay, Pagination, Navigation]}
              className="mySwiper"                
            >
              {componentData.data?.map((data, index) => {
                return (
                  <div className="item text-center" key={"testimonialblockdiv" + index}>
                    <SwiperSlide key={"testimonialblock" + index}>
                    {/* <div className="item-heading">
                      <h2 className="tmrb">1,00,000 +</h2>
                      <h4>satisfied members</h4>
                    </div> */}
                    <Link to={testimonial_urls[index] || "#"}>
                      <LazyLoadImage
                        alt={""}
                        effect="blur"
                        src={data.src || ""}
                        className="img-fluid mx-auto d-block"
                      />
                    </Link>  
                    {/* <div className="row">
                      <div className="col-md-6 mx-auto">
                        <div className="member-text mt-70">
                          <h5 className="mt-20">srishti</h5>
                          <p className="mt-20 text-black">
                            “well, I had a great experience.
                            <br />
                            The shoes are still in prime condition.”
                          </p>
                        </div>
                      </div>
                    </div> */}
                    </SwiperSlide>
                  </div>
                );
              })}
            </Swiper>
            {/* </CustomSlider> */}
          {/* </div>
        </div> */}
      </div>
    </section>
  );
}

export default TestimonialsSlider;
